import ConfirmDeleteTeachingPeriodButton from './ConfirmDeleteTeachingPeriodButton';
export default ConfirmDeleteTeachingPeriodButton;
